import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { Header, Footer, MobileMenu } from "../../components";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import route from "./../../route";
import "./DefaultLayout.css";

function Layout({ location, history }) {
  history.listen((location, action) => {
    // location is an object like window.location
    // console.log(action, location.pathname, location.state);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 5);
  });

  let containerClass = ["container"].join(" ");
  let wrapperClass = [
    "wrapper",
    window.location.pathname === "/" ||
    window.location.pathname === "/help/api-key"
      ? "snappy"
      : ""
  ].join(" ");

  let template = route.map((route, idx) => {
    return route.component ? (
      <Route
        key={idx}
        path={route.path}
        exact={route.exact}
        name={route.name}
        render={props => <route.component {...props} />}
      />
    ) : null;
  });

  return (
    <div className={containerClass}>
      <MobileMenu show />
      <TransitionGroup className="transition-group">
        <CSSTransition
          key={location.key}
          timeout={{ enter: 300, exit: 300 }}
          classNames="fade"
        >
          <div className={wrapperClass}>
            <Header />
            <Switch>
              {template}
              {/*<Redirect from="/" to="/dashboard" />*/}
            </Switch>
            <Footer />
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}

export default withRouter(Layout);
